import React from "react";
import { MdOutlineAppBlocking } from "react-icons/md";
import { FaBookAtlas } from "react-icons/fa6";
import { IoServerOutline } from "react-icons/io5";
import wave from "../../assets/wave.gif";

const ServiceData = [
  {
    title: "System",
    content: "Web Applications",
    description:
      "Designed and implemented websites and web systems for governmental and non-governmental PLCs",
    icon: <FaBookAtlas className="text-6xl" />,
    aosDelay: "300",
  },
  {
    title: "Apps",
    content: "Mobile App",
    description:
      ", we can making software for smartphones and tablets, using react-native & Flutter",
    icon: <MdOutlineAppBlocking className="text-6xl" />,
    aosDelay: "500",
  },
  {
    title: "Server",
    content: "Hosting Websites",
    description:
      "housing the files, data, and content that make up a website on a server that is connected to the Internet.",
    icon: <IoServerOutline className="text-6xl" />,
    aosDelay: "700",
  },
];
const Services = () => {
  return (
    <div className="bg-black text-white relative z-50">
      <div className="container">
        <div className="min-h-[400px]">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 relative z-50">
            {ServiceData.map((data, index) => (
              <div
                data-aos="fade-up"
                data-aos-delay={data.aosDelay}
                className="min-h-[180px] flex flex-col gap-2 justify-center items-center bg-sky-900/60 rounded-xl backdrop-blur-sm text-center text-2xl py-8 px-3 w-full lg:w-[300px] mx-auto"
              >
                {data.icon}
                <h1>{data.title}</h1>
                <p>{data.content}</p>
                <p className="text-sm">{data.description}</p>
              </div>
            ))}
          </div>
          <img
            src={wave}
            alt=""
            className="h-[200px] w-full object-cover mix-blend-screen -translate-y-24 relative z-[0]"
          />
        </div>
      </div>
    </div>
  );
};

export default Services;
